module.exports = __webpack_public_path__ + "media/images/bus/conditions/AAFO-43aef7eb5b0f9122c14571957fe3265f.svg";